module.exports = __webpack_public_path__ + "static/media/elegir_metodo_run_serial_preguntas_clave_unica.15aec960.svg";